import Layout from '../../components/layout/layout'

export default function PrivacyPolicy({siteConfig}) {
  return (
    <Layout isFixed={true} siteConfig={siteConfig}>

    <div className="bg-white px-6 py-32 lg:px-8">
      <div dangerouslySetInnerHTML={{ __html: siteConfig?.privacy_policy?.content ?? '' }} />
    </div>

    </Layout>

  )
}
